import { AxiosRequestConfig } from 'axios';

import {
  IGetTechnicalIndicatorParams,
  IGetUserPreferenceParams,
  IOrderColumnPreference,
  IOrderColumnPreferenceV2Map,
  ITechnicalIndicator,
  IUpdateLanguage,
  IUpdateOrderColumnPreferenceParams,
  IUpdateOrderColumnPreferenceParamsV2,
  IUpdateTechnicalIndicatorParams,
  IUpdateUserPreferenceParams,
  IUserPreference
} from '@aqx-core/common/api/user-account-setting';
import { request } from '@aqx-core/common/request';

export default {
  getTechnicalIndicator: (params?: IGetTechnicalIndicatorParams, retry?: number) =>
    request.get<ITechnicalIndicator[]>('/api/user/setting/v1/indicator', { params, retry }),
  updateTechnicalIndicator: (params: IUpdateTechnicalIndicatorParams, signal?: AbortSignal) =>
    request.patch<boolean>('/api/user/setting/v1/indicator', params, { signal }),
  updateLanguage: () => request.patch<IUpdateLanguage>('/api/user/setting/v1/language/platform'),
  qrCode: () => request.get<string>('/api/user/setting/v1/mobile/qrcode'),
  getAllColumnPreferences: (config?: AxiosRequestConfig) =>
    request.get<IOrderColumnPreference[]>('/api/user/v1/order/hide/preference', config),
  hideColumnPreferences: (params: IUpdateOrderColumnPreferenceParams, config?: AxiosRequestConfig) =>
    request.patch<boolean>('/api/user/v1/order/hide/preference', { ...params, config }),
  getOrderColumnPreferences: (signal?: AbortSignal) =>
    request.get<IOrderColumnPreference[]>('/api/user/setting/v1/order/hide/preference', { signal }),
  getAllColumnPreferencesV2: (config?: AxiosRequestConfig) =>
    request.get<IOrderColumnPreferenceV2Map>('/api/user/v2/order/hide/preference', config),
  updateOrderColumnPreference: (params: IUpdateOrderColumnPreferenceParams) =>
    request.patch<boolean>('/api/user/setting/v1/order/hide/preference', params),
  updateOrderColumnPreferenceV2: (params: IUpdateOrderColumnPreferenceParamsV2) =>
    request.put<boolean>('/api/user/v2/order/hide/preference', params),
  getUserPreference: (params?: IGetUserPreferenceParams) =>
    request.get<IUserPreference[]>('/api/user/setting/v1/preference', { params }),
  updateUserPreference: (params: IUpdateUserPreferenceParams, signal?: AbortSignal) =>
    request.patch<boolean>('/api/user/setting/v1/preference', params, { signal })
};
